import React from 'react'
import Drawer from '@material-ui/core/Drawer'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import { GeneralConsumer } from '../../context/GeneralContext'
import MobileMenuUserActions from './MobileMenuUserActions'
import MainNavigation from '../MainNavigation'
import { useStyles } from './Styles'
import { AuthConsumer } from '../../context/AuthContext'
import { Avatar } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import PersonIcon from '@material-ui/icons/Person'
import { LanguageConsumer } from '../../context/LanguageContext'

const MobileMenu = () => {
  const classes = useStyles()

  return (
    <GeneralConsumer>{({ mobileMenuState, toggleMobileMenuDrawer }) => (
      <>
        <div>
          <IconButton
            edge="end"
            className={classes.menuButton}
            aria-label="open drawer"
            onClick={() => toggleMobileMenuDrawer(true)}
          >
            <MenuIcon/>
          </IconButton>
        </div>
        <Drawer className={classes.navigationDrawerWrapper} anchor='right' open={mobileMenuState}
                onClose={() => toggleMobileMenuDrawer(false)}>
          <div className={classes.navigationDrawer}>
            <IconButton
              edge="end"
              className={classes.menuCloseButton}
              color="inherit"
              aria-label="close drawer"
              onClick={() => toggleMobileMenuDrawer(true)}
            >
              <CloseIcon/>
            </IconButton>
            <AuthConsumer>
              {({ userData, taxpayerData }) => (
                <LanguageConsumer>
                  {({ locale }) => (
                    <div className={classes.userNameWrapper}>
                      <Avatar className={classes.userAvatar}>
                        <PersonIcon/>
                      </Avatar>
                      <div className={classes.menuUserName}>
                        {(!!Object.keys(userData || {}).length && !!Object.keys(taxpayerData || {}).length) ? (
                          <>
                            <strong>{locale === 'ar' ? taxpayerData?.name_ar || taxpayerData?.name : taxpayerData?.name}</strong>
                            <span>{locale === 'ar' ? `${userData?.first_name_ar} ${userData?.last_name_ar}` || `${userData?.first_name} ${userData?.last_name}` : `${userData?.first_name} ${userData?.last_name}`}</span>
                            {/*{!!userData?.email && <span>({userData?.email})</span>}*/}
                          </>
                        ) : <FormattedMessage id='UserMenu.username'/>}

                      </div>
                    </div>
                  )}
                </LanguageConsumer>
              )}
            </AuthConsumer>
            <MainNavigation/>
            <MobileMenuUserActions toggleMobileMenuDrawer={toggleMobileMenuDrawer}/>
          </div>
        </Drawer>
      </>
    )}
    </GeneralConsumer>
  )
}

export default MobileMenu
